// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"gJ-z","smallCardRow":"hJ-z","largeCardRow":"iJ-z","productSearchRow":"jJ-z","curatedRow":"kJ-z"};